import { SIGNED_URL } from './constants';

export const uploadFile = async (file: File) => {
  const [name] = file.name.split('.');
  const fileName = encodeURIComponent(name + new Date().toISOString());

  const uploadLink = await fetch(SIGNED_URL(fileName), {
    method: 'POST',
  });

  if (!uploadLink) {
    return '';
  }

  const { url, fields } = await uploadLink.json();
  const formData = new FormData();
  Object.entries({ ...fields }).forEach(([key, value]) => {
    formData.append(key, value as string);
  });
  formData.append('file', file);
  try {
    const uploadRes = await fetch(url, {
      method: 'POST',
      body: formData,
    });

    return uploadRes.ok
      ? `https://storage.cloud.google.com/${process.env.NEXT_PUBLIC_BUCKET_NAME}/${fileName}?authuser=0`
      : '';
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('err', err);
    return '';
  }
};
